import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { RouterLink, Router, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import {
  ShamLockPasswordBulkIcon,
  ShamMail01BulkIcon,
  ShamPhone03Icon,
} from 'sham-components/icons';
import { ShamSlidesSwiper } from 'sham-components/elements/slides-swiper';
import { TranslateModule } from '@ngx-translate/core';
import { AuthApi } from '@/app/services/auth-api';

@Component({
  selector: 'app-email-verification',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './email-verification.html',
  styleUrl: './email-verification.css',
})
export class EmailVerificationPage {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private authApi = inject(AuthApi);

  flow = '';
  email = '';
  userId = '';

  otpArray = new Array(6).fill('');
  timer = signal('00:45');

  isLoading = signal(false);
  errorMessage = signal('');

ngOnInit() {
  const authData = this.authApi.getAuthFlowData();

  this.flow = authData.flow || '';
  this.email = authData.email || '';
  this.userId = authData.userId || '';

  if (!this.email || !this.flow) {
    this.router.navigate(['/auth/login']);
    return;
  }
}

  onInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '');
    if (!digits) {
      this.otpArray[index] = '';
      input.value = '';
      return;
    }
    this.fillDigits(input, index, digits);
  }

  onPaste(event: ClipboardEvent, index: number) {
    const text = event.clipboardData?.getData('text');
    if (text === undefined) return;
    event.preventDefault();
    const digits = text.replace(/\D/g, '');
    if (digits) this.fillDigits(event.target as HTMLInputElement, index, digits);
  }

  private fillDigits(input: HTMLInputElement, index: number, digits: string) {
    const inputs = Array.from(input.closest('div[dir="ltr"]')!.querySelectorAll('input'));
    const start = digits.length >= this.otpArray.length ? 0 : index;
    const count = Math.min(digits.length, this.otpArray.length - start);
    for (let i = 0; i < count; i++) {
      this.otpArray[start + i] = digits[i];
      inputs[start + i].value = digits[i];
    }
    inputs[Math.min(start + count, inputs.length - 1)]?.focus();
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && !input.value && index > 0) {
      const prevInput = input.parentElement?.previousElementSibling?.querySelector('input');
      prevInput?.focus();
    }
  }

  onVerify() {
    const otpCode = this.otpArray.join('');
    this.errorMessage.set('');

    if (!/^\d{6}$/.test(otpCode)) {
      this.errorMessage.set('يرجى إدخال الكود كاملاً');
      return;
    }

    this.isLoading.set(true);

    if (this.flow === 'register') {
      this.authApi.confirmEmail({
        email: this.email,
        code: otpCode
      }).subscribe({
        next: (res) => {
          this.isLoading.set(false);
            this.authApi.clearAuthFlowData();

          this.router.navigate(['/auth/register/success']);
        },
        error: (err) => this.handleError(err)
      });

    } else if (this.flow === 'forgot-password') {
      this.authApi.verifyPasswordResetOtp({ email: this.email, otpCode: otpCode }).subscribe({
        next: (res) => {
          this.isLoading.set(false);
       this.authApi.setAuthFlowData({
  email: this.email,
  flow: 'forgot-password',
  resetToken: res.resetToken
});

this.router.navigate(['/auth/reset-password']);
        },
        error: (err) => this.handleError(err)
      });
    }
  }

  private handleError(err: any) {
    this.isLoading.set(false);
    if (err.error?.message) {
      this.errorMessage.set(err.error.message);
    } else {
      this.errorMessage.set('حدث خطأ أثناء التحقق من الكود. يرجى المحاولة مرة أخرى.');
    }
  }
}
